import React from "react";
import { useTimedCounter } from "../hooks/useTimedCounter";
import { logOutOfIdp } from "../utils/logout/logout";
import { AuthContextProps } from "react-oidc-context";
import { EndSessionAction } from "../lib/types";

const defaultCountdownSeconds: number = 10;

/**
 * Displays "To begin using your new credentials, you will be logged out and redirected in {count} seconds.",
 * and then begins RP-initiated logout
 */
export const LogoutCountDown = (props: {
  auth: AuthContextProps;
  startingSeconds?: number;
}) => {
  const { count } = useTimedCounter({
    start: props.startingSeconds ?? defaultCountdownSeconds,
    end: 0,
    by: -1,
    interval: 1000,
    onComplete: () => {
      logOutOfIdp({
        auth: props.auth,
        action: EndSessionAction.ActionEndSession,
      });
    },
  });

  return <>You will be automatically logged out in {count} seconds.</>;
};
